// extracted by mini-css-extract-plugin
export default {"site-performance-container":"SitePerformance_site-performance-container__Djdo7","site-performance-header":"SitePerformance_site-performance-header__pMFR1"};